<template>
  <div>
    <div class="container-fluid pt-5 pb-6 pt-lg-6 pb-lg-6 timetable-container topchik">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="breadcrumbs">
              <a href="/">Главная</a> / Запись на индивидуальные занятия
            </div>
          </div>
        </div>
        <div class="row pdtop50px">
          <div class="col-12">
            <div class="row" v-if="error">
              <div class="col-lg-12">
                <base-alert type="danger" dismissible>{{ error }}</base-alert>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-8 schedules-header">
                <h1 style="font-family: 'Manrope Bold'; margin-bottom: 20px;">Запись на индивидуальные занятия</h1>
              </div>
              <div class="col-12 col-sm-4">
                <a href="/home-teacher/schedule">
                  <div class="group">Групповые занятия <img src="@/assets/hometeacher/images/rarr.png"></div>
                </a>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-lg-12">
                <p class="px18">Индивидуальные занятия &ndash; <span class="strong-black">правильный выбор</span>, если
                  вы цените персональный подход! </p>

                <p class="px18">Этот формат обучения позволяет учесть индивидуальные особенности ребёнка при проведении
                  уроков и составить оптимальный план занятий, исходя из ваших потребностей.</p>

                <p class="px18"><span class="strong-black">Оформите абонемент на онлайн-занятия прямо сейчас.</span><br>
                  После оплаты наш специалист свяжется с вами для согласования графика обучения и обсуждения всех
                  организационных вопросов.</p>

                <p class="px18">Для предварительной консультации, пожалуйста,
                  <router-link to="/entry" style="color: #0493c3; font-weight: bold;">свяжитесь с нами, оставив заявку
                  </router-link>
                  .
                </p>
              </div>
            </div>
            <div class="row" v-if="groupedSubscriptions">
              <div class="col-12">
                <h2 class="blackh2 text-center text-lg-left">Стоимость обучения</h2>
              </div>
            </div>
            <div class="row mt-1 mb-4 justify-content-center" v-if="groupedSubscriptions">
              <div class="col-lg-4 col-12 ind-lang-selector" v-for="lang in languages" :key="lang">
                  <span :class="{'is-active': selectedLanguage === lang }" @click="selectedLanguage = lang">
                    {{ lang }} язык
                  </span>
              </div>
            </div>
            <div class="row ml-lg-0 ml-5  mr-lg-0 mr-5" v-if="groupedSubscriptions">
              <div class="col-12" v-for="lang in languages" :key="lang">
                <SubscriptionsList v-if="groupedSubscriptions.get(lang) && selectedLanguage === lang"
                                   :subscriptions="groupedSubscriptions.get(lang)"
                                   :lg-count="4"
                                   @order="orderSubscription"
                                   @bonusCourseClick="bonusCourseClick"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid blue-wave-top"></div>
    <div class="container-fluid blueback fr-page" id="feedback">
      <div class="container align-middle ">
        <div class="row prezent">
          <div class="col-12 col-sm-9">
            <h2>Не знаете что подарить?</h2>
            <h3>Отличный выбор &ndash; подарочный сертификат на курс </h3>
            <a href="" class="mobile-vers"><img src="@/assets/hometeacher/images/prezent.png" style="max-width: 100%;"></a>
            <p class="px18">Приобретите именной подарочный сертификат на нашем сайте, распечатайте его и подарите.<br>
              Сертификат предоставляет единоразовую <span class="strong-black">100% скидку на курс.</span></p>
            <p>&nbsp;</p>
            <a href="" class="orange-knp">Купить подарочный сертификат</a>
          </div>

          <div class="col-12 col-sm-3">
            <a href="" class="desktop-vers"><img src="@/assets/hometeacher/images/prezent.png"></a>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid blue-wave-bottom"></div>

    <div class="container-fluid white-bg no-shadow fr-page pdtop50px">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="blackh2">Преподаватели</h2>
            <p class="px18">Наши профессиональные преподаватели, имеющие опыт в обучении иностранным языкам и развитии
              детей, быстро найдут подход к ребенку.
              <span class="strong-black">Обучение ведется на том языке, который выбрали родители.</span></p>

          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid green-wave-top"></div>
    <div class="container-fluid green-feedback centers-list sshadow">
      <div class="container align-middle">
        <div class="row">
          <div class="col-12">
            <h2 class="yazik">Каким языкам обучаем</h2>
          </div>
        </div>

        <div class="row green-lng">
          <div class="col-12 col-sm-4 text-center">
            <div class="lng">
              <img class="en-img" src="@/assets/hometeacher/images/i-en-green.png">
              <p>Английский</p>
            </div>
            <div class="lng">
              <img src="@/assets/hometeacher/images/i-fr-green.png">
              <p>Французский</p>
            </div>
          </div>
          <div class="col-12 col-sm-4 text-center">
            <div class="lng">
              <img class="de-img" src="@/assets/hometeacher/images/i-de-green.png">
              <p>Немецкий</p>
            </div>
            <div class="lng">
              <img class="es-img" src="@/assets/hometeacher/images/i-es-green.png">
              <p>Испанский</p>
            </div>
          </div>
          <div class="col-12 col-sm-4 text-center">
            <div class="lng">
              <img class="ch-img" src="@/assets/hometeacher/images/i-ch-green.png">
              <p>Китайский</p>
            </div>
            <div class="lng">
              <img class="ru-img" src="@/assets/hometeacher/images/i-ru-green.png">
              <p>Русский</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid green-wave-bottom"></div>

    <div class="container-fluid white-bg no-shadow fr-page pdtop50px mbpt">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="blackh2">На индивидуальных занятиях:</h2>
          </div>
        </div>
        <div class="row nazan">
          <div class="col-12 col-sm-6">
            <div style="max-width: 510px;">
              <div><img src="@/assets/hometeacher/images/okn.png">
                <p class="px18">Всё время уделяется одному ребенку.</p></div>
              <div><img src="@/assets/hometeacher/images/okn.png">
                <p class="px18">Расписание может быть гибким.</p></div>
              <div><img src="@/assets/hometeacher/images/okn.png">
                <p class="px18">Преподаватель составляет индивидуальный план с учетом сильных и слабых сторон
                  ребенка.</p></div>
              <div><img src="@/assets/hometeacher/images/okn.png">
                <p class="px18">Нужно повторить тему &ndash; сделаем. Не получается аудирование &ndash; наверстаем.
                  Сложности с произношением &ndash; исправим!</p></div>
            </div>
          </div>

          <div class="col-12 col-sm-6">
            <div style="max-width: 510px;">
              <div><img src="@/assets/hometeacher/images/okn.png">
                <p class="px18">Учитесь в своем темпе &ndash; активность ребенка задает темп прохождения курса.</p>
              </div>
              <div><img src="@/assets/hometeacher/images/okn.png">
                <p class="px18">Задаем домашние задания и контролируем их выполнение.</p></div>
              <div><img src="@/assets/hometeacher/images/okn.png">
                <p class="px18">Ребенок опирается только на свои успехи, без оглядки на других.</p></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <h2 class="blackh2">Индивидуальный онлайн-урок &ndash; это:</h2>

            <div class="indivurok">
              <div class="urk">Пополнение словарного запаса с носителем</div>
            </div>
            <div class="indivurok">
              <div class="urk">Индивидуальное расписание</div>
            </div>
            <div class="indivurok">
              <div class="urk">Инновационно</div>
            </div>
            <div class="indivurok">
              <div class="urk">Психологически комфортно</div>
            </div>
            <div class="indivurok">
              <div class="urk">Доступно</div>
            </div>
            <div class="indivurok">
              <div class="urk">Весело</div>
            </div>
            <div class="indivurok">
              <div class="urk">Познавательно</div>
            </div>
            <div class="indivurok">
              <div class="urk">Общение без границ</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--
          <div class="container-fluid white-bg centers-list urok no-shadow">
            <div class="container align-middle">
              <div class="row">
                <div class="col-12">
                  <div class="skill-wrapper">
                    <div class="skill-text skill-text-1"><span>Пополнение словарного запаса с носителем</span></div>
                    <div class="skill-text skill-text-2"><span>Индивидуальное расписание</span></div>
                    <div class="skill-text skill-text-3"><span>Инновационно</span></div>
                    <div class="skill-text skill-text-4"><span>Психологически комфортно</span></div>
                    <div class="skill-text skill-text-5"><span>Доступно</span></div>
                    <div class="skill-text skill-text-6"><span>Весело</span></div>
                    <div class="skill-text skill-text-7"><span>Познавательно</span></div>
                    <div class="skill-text skill-text-8"><span>Общение без границ</span></div>
                    <img src="@/assets/hometeacher/images/girl-obl.png">
                  </div>
                </div>
              </div>
            </div>
          </div>
          -->
    <div class="container-fluid white-bg centers-list fr-page no-shadow">
      <div class="container align-middle">
        <div class="row">
          <div class="col-12">
            <div class="land-t-delimeter" style="margin-top: 30px;"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <h2><span class="strong-black">Отзывы об онлайн-уроках</span></h2>
            <p>&nbsp;</p>
          </div>
        </div>
        <div class="row mention justify-content-center">
          <div class="col-12 col-sm-2 m-photo">
            <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                               src="@/assets/hometeacher/images/nataliya-yuferova.jpg"></a>
          </div>
          <div class="col-12 col-sm-10 home-mention">
            <span class="dateotzyv">24.05.2021</span>
            <span class="nameotzyv">Наталия Юферова <a href="https://vk.com/id4037847" target="_blank">vk.com</a></span><br>

            <span class="textotzyv">Добрый день. Хочу поделиться опытом занятий с Полиглотиками. Присоединились мы осенью 2020 года. Дочке было 5 лет, ранее знакомства с английским языком не было. На Полиглотиков наткнулась случайно: заинтересовал он-лайн формат обучения при многообразии уроков. Я всегда за обучение в формате игр, а тут и music class, и story time, и art class. На первый урок попали к Виктории, с нами были ещё несколько ребят, которые уже ориентировались в английском. Хочу сразу сказать огромное спасибо преподавателям за их чуткость к детям, заинтересованность в их обучении, благожелательность, жизнерадостность и внимание! Спасибо за то, что прививаете любовь к языкам нашим детям! Сразу скажу, что дочка первые занятия не понимала и не запоминала слова, но была увлечена, с нетерпением ждала уроков, и правильный ответ для неё был маленькой победой! Мне в свою очередь было очень удобно он-лайн обучение: мы были на дистанционной работе, а ребёнка можно было просто посадить рядом и подсказывать при необходимости. Сейчас это также удобно, потому что если мы не успеваем, то подключиться к уроку дочка может или сама, или бабушка поможет, не нужно никуда собираться и ехать. А иногда я занимаюсь домашними делами, а ребёнок рядом занимается. При этом мы, родители, знаем, что дети проходят, можем помочь, повторить слова, вводить их в повседневный разговор, скачать изучаемые песни, чтобы вместе попеть, почитать книжку на русском, ту, которую читали на английском на уроках (это просто огромный плюс). А ещё дети неохотно отрываются от своих игр и маленьких дел даже ради любимых занятий, а тут можно даже игрушки не убирать, просто переместиться за стол, а по окончании вернуться в игру. По самим урокам: мне нравится наполненность, дозированность информации в сочетании с переменками в виде песенок с движениями-дети не успевают ни заскучать, ни устать. Поделки с art класса мы носили в садик, дарили в виде новогодних подарков родственникам - темы поделок всегда актуальны. Ещё раз спасибо всем нашим преподавателям! И за обратную связь! Как результат занятий - дочка может пройти этап знакомства, ответить на вопросы о любимых игрушках/блюдах/цветах, рассказать о погоде и описать человека, а ещё спеть пару песенок на английском, но под фонограмму :))) и выдать слова, которые мы вроде не проходили, но встречали на уроках story time. Надеюсь, что дальше будет только увлекательнее и интереснее.</span>

          </div>
        </div>
        <div class="row mention justify-content-center">
          <div class="col-12 col-sm-2 m-photo">
            <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                               src="@/assets/hometeacher/images/nadya-brandaus.jpg"></a>
          </div>
          <div class="col-12 col-sm-10 home-mention">
            <span class="dateotzyv">21.05.2021</span>
            <span class="nameotzyv">Nadya Brandaus <a href="https://vk.com/id294529857"
                                                      target="_blank">vk.com</a></span><br>

            <span class="textotzyv">Моя дочь семилетка занимается с «Полиглотиками» уже полгода. И каждый раз ждёт новое занятие как праздника. Для меня удивительно, почти час ребёнок погружен в процесс, слушает и отвечает с удовольствием. Преподаватели - просто волшебники! Моя дочь очень застенчива, легко отвлекается, до этого мы пробовали несколько курсов, где не получалось. «Полиглотики» придали ребёнку самоуверенности. Дочка выучила много новых слов и выражений, стала разговаривать и напевать на английском. Мы очень рады, что нашли вас! Удачи всем!</span>

          </div>
        </div>

        <div class="row mention justify-content-center">
          <div class="col-12 col-sm-2 m-photo">
            <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                               src="@/assets/hometeacher/images/no-avatar-1.png"></a>
          </div>
          <div class="col-12 col-sm-10 home-mention">
            <span class="dateotzyv">20.05.2021</span>
            <span class="nameotzyv">Olia Foro <a href="https://vk.com/o.foro" target="_blank">vk.com</a></span><br>

            <span class="textotzyv">В поисках подходящей онлайн школы английского языка для мы перепробовали огромное количество различных школ, но у ребенка пропадал интерес после нескольких уроков. Но попав в эту школу, мы остаёмся тут на долго. Прекрасные преподаватели, которые умеют увлечь маленьких непосед, служба поддержки, которая всегда на связи и оперативно отвечает на все запросы, огромное количество различных занятий. Ребенок с нетерпением ждет каждого урока, всегда есть обратная связь, групповые занятия проходят очень весело и продуктивно. Всегда учитываются пожелания клиента. Очень рады быть с Вами!!!</span>

          </div>
        </div>
        <div class="row mention justify-content-center">
          <div class="col-12 col-sm-2 m-photo">
            <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                               src="@/assets/hometeacher/images/vera-kondrateva.jpg"></a>
          </div>
          <div class="col-12 col-sm-10 home-mention">
            <span class="dateotzyv">18.05.2021</span>
            <span class="nameotzyv">Вера Кондратьева <a href="https://www.facebook.com/profile.php?id=100008304612517"
                                                        target="_blank">facebook.com</a></span><br>

            <span class="textotzyv">Дорогие мамочки обучающие своих детей иностранным языкам с молодых ногтей, ЭТО ТОЧНО ДЛЯ ВАС. Мы нашли замечательную платформу https://poliglotiki.com для изучения англ языка.<br>
                      Уроки проходят с понедельника по субботу 2 раза в день, группы представлены разные от 3 до 17 лет, причем мы живем в Доминикане и по нашему часовому поясу занятия также проходят в 10,11.12,13 по местному, т.е. вечером по Москве. Занятия классные, в игровой форме, для начинающих деток проходит обучение в форме игры, занятий по рисованию, чтение сказок, поем песенки и ВСЕ на англ. Для нас это выход, ребенок общается с другими детьми, постоянно слушает англ речь. Цены не просто доступные, а супердоступные. Первые 3 дня бесплатно, смотрите, пробуете. Мы намучались выбирая разные платформы и способы обучения, многие просто берут неадекватные деньги за те же самые услуги, устраивает все от качества,формы преподования, до цены и внеурочного общения с менеджерами. Это лучшая платформа, что мы встречали по изучению англ языка, там есть и другие языки, но мы пока учим англ. Хотела поделиться с теми, кто также как мы давно ищет нечто подобное и не может найти, я как мать двоих детей, обучающая своих детей дома, понимаю и знаю как это тяжело, поэтому решила сделать здесь пост, кому то надеюсь очень поможет, а вы когда нибудь поделитесь тоже чем то интересным и так общими усилиями будем помогать друг друг в этом нелегком дете воспитания наших деток. Я не менеджер ответов на вопросы не даю, если есть вопросы пишите им лично, сайт я указала. Всем хорошего дня!!</span>

          </div>
        </div>
        <div class="row mention justify-content-center">
          <div class="col-12 col-sm-2 m-photo">
            <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                               src="@/assets/hometeacher/images/elena-serebryakova.jpg"></a>
          </div>
          <div class="col-12 col-sm-10 home-mention">
            <span class="dateotzyv">27.02.2021</span>
            <span class="nameotzyv">Елена Серебрякова <a href="https://vk.com/id426090428" target="_blank"
                                                         rel="nofollow">vk.com</a></span><br>

            <span class="textotzyv">Ребенок занимается несколько раз в неделю. Преподаватели все интересные, даже есть носители языка со знанием русского. Дети всегда могут обратиться и на русском, и на английском языках. В занятиях красочные задания, песни; преподаватели всегда интересуются качеством связи, чтобы слышать всех учеников. Поправляют ошибки вежливо, без придирок, всегда обращают внимание на правильность произношения. Занятий много в расписании, можно посещать любые. Преподаватели знакомятся с каждым ребенком, нет чувства, что занимаешься с чужим человеком. К каждой теме, есть тематическая песня. На музыкальных занятиях изучают песни, по строчкам проговаривая текст.</span>
          </div>
        </div>

        <div class="row mention justify-content-center">
          <div class="col-12 col-sm-2 m-photo">
            <a href="javascript:void(0);"><img class="photootzyv" alt=""
                                               src="@/assets/hometeacher/images/marina-fedorina.jpg"></a>
          </div>
          <div class="col-12 col-sm-10 home-mention">
            <span class="dateotzyv">22.01.2021</span>
            <span class="nameotzyv">Марина Федорина <a href="https://vk.com/id42068522" target="_blank"
                                                       rel="nofollow">vk.com</a></span><br>

            <span class="textotzyv">Всем доброго дня! Хочу рассказать об онлайн курсах английского языка от  #полиглотиков.<br>
                    Старший сын учится в третьем классе, второй год изучает английский. Пошёл Миша в сентябре в школу, а учитель английского заболела, а потом и мы все заболели. Начала я искать, где можно английский подтянуть. Все заведения по дополнительному образованию в городе закрыты из-за карантина. Наткнулась на #полиглотиков, там как раз была акция 2 недели бесплатного обучения с онлайн учителем по зуму. Решили попробовать, вроде, понравилось. Миша «ходит» в группу для младших школьников. Вначале слова учили по темам, сейчас грамматика пошла. Втянулся, раньше спрашивал, когда занятия, сейчас сам уже всё расписание выучил, лучше меня знает. В школе тоже пятёрки «пошли» по английскому.<br>
                    Среднего из садика тоже на карантин «высадили», кружки все на дистанционном обучении, только задания присылают. А когда с ним все занятия выполнять… Хотелось, чтобы сам иногда занимался. Решили с Максимом тоже английский начать учить. Записала его в группу для начинающих возраст 5-6 лет. И не пожалела. Сейчас, через 3 месяца уже отвечает на вопросы о себе, о семье может немного рассказать, цвета знает и счёт до 10. Хотя до этого вообще английский не учил. Нравится, как преподаватель с ними работает, слова наглядно на картинках плюс подписаны на английском идёт зрительное и слуховое запоминание. Песенку в начале каждого занятия поют, уже вся семья выучила) Игры разнообразные на закрепление слов. У Максима азарт такой во время игры, первый раз даже не поняла, почему он у меня там кричит во время занятия.<br>
                    Единственное, мне кажется, Максиму не хватает начальных знаний, типа изучение алфавита. И время не всегда удобное, у нас 2 часа разница с московским, занятия иногда в 9 вечера. На курсе 2 варианта занятия днём в 12-13 и вечером в 8-9 вечера. Когда сидим дома, занимаемся днём, когда в садик ходим, то вечером. Хотя что Миша, что Максим готовы на все занятия ходить… и днём и вечером.<br>
                    Программа, в которой проходят занятия простая. 6-летний сын сам разобрался, что где включать.<br>
                    Учителя замечательные, хвалят, подбадривают, стараются всем внимания уделить. В дневных группах мало народа, иногда 1-2 человека занимаются, получается индивидуальное занятие, в вечерних больше — по 6-8 в среднем. В общем, всем, кто хочет поднятуть ребёнка по английскому, или начать изучать очень советую онлайн-курс от #полиглотиков «OnlineTeacher».<br>
                    Ах, да, ещё кроме основных занятий есть дополнительные «Арт класс», «мьюзик класс» и «стори тайм», где дети мастерят, рисуют, поют песни и слушают истории. Занятия проходят легко и весело. Спасибо всем преподавателям школы #полиглотиков.</span>
          </div>
        </div>

      </div>
    </div>
    <Entry/>

  </div>
</template>
<script>

import moment from 'moment';
import SubscriptionsList from "./Subscriptions/SubscriptionsList";
import subscriptionApi from "../data/SubscriptionApi";
import Entry from "./Entry";
import {isAuthenticated} from "../data/jwt.service";
import userApi from "../data/UserApi";


export default {
  components: {
    Entry,
    SubscriptionsList,
  },
  name: 'individuals',

  data: function () {
    return {
      title: null,
      assignDialog: false,
      selectedEvent: null,
      selectedCourse: null,

      error: null,
      fieldsErrors: [],
      childFieldsErrors: [],
      loading: false,

      subscriptions: null,
      languages: ['Английский', 'Испанский',],
      selectedLanguage: 'Английский',
      groupedSubscriptions: null
    }
  },

  metaInfo() {
    return {
      title: 'Запись на индивидуальные занятия',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: '☝☝☝☝☝ «OnlineTeacher» – это домашний педагог, для встречи с которым не нужно никуда идти!'
        }
      ]
    }
  },

  mounted() {
    moment.locale(this.$i18n.locale)
    this.loading = true

    if (isAuthenticated()) {
      userApi.fetchProfile()
          .then(response => {
            //Исключаем одноразовые промо подписки
            let ids = response.oneOffSubscriptionIds
            subscriptionApi.fetchIndividualSubscriptions()
                .then(response => {
                  this.subscriptions = response.filter(s => ids.indexOf('' + s.idsubscription) === -1)
                  this.groupedSubscriptions = this.groupByLanguages(this.subscriptions)
                })
                .catch(error => {
                  let data = error.response.data
                  this.error = this.pretty(data)
                  this.loading = false
                })
          })
          .catch(error => {
            let data = error.response.data
            this.error = this.pretty(data)
            this.loading = false
          })
    } else {
      subscriptionApi.fetchIndividualSubscriptions()
          .then(response => {
            this.subscriptions = response
            this.groupedSubscriptions = this.groupByLanguages(this.subscriptions)
          })
          .catch(error => {
            let data = error.response.data
            this.error = this.pretty(data)
            this.loading = false
          })
    }

  },

  methods: {
    groupByLanguages(subscriptions) {
      let grouped = new Map()
      this.languages.forEach(function (lang) {
        let subsGroup = []
        subscriptions.forEach(function (sub) {
          if (sub.subscription.includes(lang)) {
            subsGroup.push(sub)
          }
        });
        subsGroup.sort((a, b) => (parseInt(a.price) > parseInt(b.price)) ? 1 : -1)
        grouped.set(lang, subsGroup)
      });
      return grouped
    },

    fieldError(fieldName) {
      let errors = []
      if (this.fieldsErrors) {
        this.fieldsErrors.filter(field => {
          if (field.field === fieldName) {
            errors.push(field.message)
          }
        })
      }
      if (errors.length > 0)
        return errors.join(', ')
      return null
    },
    pretty(value) {
      console.log(value)
      if (value.message) {
        return value.message
      }
      return JSON.stringify(value, null, 2)
    },

    orderSubscription(subscription) {
      this.$router.push('/subscription/order/' + subscription.idsubscription)
    },

    bonusCourseClick(subscription) {
      if (subscription.courses && subscription.courses.length > 0) {
        this.$router.push('/course/' + subscription.courses[0].slug)

      }
    },
  }
};
</script>
<style src="@/assets/hometeacher/css/main.css">
</style>
<style lang="scss" scoped>
.group {
  background: #e9dfa3;
  color: #231c37;
  text-align: center;
  border-radius: 22px;
  padding: 5px;
  width: 245px;
  float: right;
  font-size: 18px;
  font-family: 'Manrope Bold';
}

.group:hover {
  border: 1px solid grey;
  padding: 4px;
}

.group img {
  margin-left: 2px;
}

.topchik {
  padding-top: 10px !important;
  box-shadow: inset 0 3px 5px #00000038;
  margin-bottom: -10px;
}

.pdtop50px {
  padding-top: 50px;
}

.blue-wave-bottom {
  background-image: url(~@/assets/hometeacher/images/blue-wave-bottom.png);
  background-repeat: no-repeat;
  background-position: top;
  background-size: 100% 14px;
  height: 14px;
}

.prezent {
  text-align: left;
  padding-top: 20px;
}

.prezent h2 {
  font-family: 'Manrope Bold';
  font-size: 30px !important;
  color: #5ab947;
  margin-top: 20px;
}

.prezent h3 {
  font-family: 'Manrope Bold';
  font-size: 24px !important;
  color: #5ab947;
  margin-bottom: 15px;
}

.prezent img {
  float: right;
  max-width: 100%;
}

.orange-knp {
  background: #f15b22;
  border-radius: 5px;
  padding: 14px 20px;
  color: #ffffff;
  font-size: 18px;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
}

.orange-knp:hover {
  color: #ffffff;
  background: #f97745;
}

.yazik {
  color: #caffbb;
  text-align: center;
  font-size: 30px;
  font-family: "Manrope Bold";
  margin-bottom: 50px;
  padding-top: 10px;
}

.lng {
  font-family: Manrope Bold;
  width: 120px;
  float: left;
  margin-right: 39px;
  margin-left: 15px;
}

.green-lng p {
  font-size: 18px;
  color: #fff;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
  font-family: "Manrope Bold";
}

.green-lng {
  text-align: center;
}

.green-lng img {
  margin-bottom: 3px
}

.en-img {
  margin-top: 1px;
}

.de-img {
  margin-top: 4px;
}

.es-img {
  margin-top: 2px;
}

.ch-img {
  margin-top: 12px;
}

.ru-img {
  margin-top: 8px;
}

.green-lng p {
  font-size: 18px;
  color: #fff;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
  font-family: "Manrope Bold";
  padding-top: 7px;
}

.green-lng {
  padding-bottom: 50px !important;
}

.nazan {
  padding-bottom: 60px;
}

.nazan img {
  margin-right: 10px;
  float: left;
  margin-top: 5px;
}

.nazan p {
  margin-left: 31px !important;
}

.urok {
  background-image: url(~@/assets/hometeacher/images/oblaka.png);
  height: 458px;
  background-position: top;
  background-repeat: no-repeat;
  margin-top: -2px;
  margin-bottom: 100px;
}

.skill-wrapper {
  text-align: center;
}

.skill-wrapper img {
  margin-top: 90px;
  margin-left: -90px;
  z-index: 10;
  position: relative;
}


.skill-text {
  font-family: Manrope Bold;
  font-size: 18px;
  line-height: 18px;
  border: 3px solid;
  /*border-radius: 50%;*/
  position: absolute;
  text-align: center;
  padding-left: 20px;
  padding-right: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-line-pack: center;
  align-content: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.skill-text span {
  margin: auto 0;
}

.skill-text-1 {
  border-color: #b01ced;
  color: #b01ced;
  width: 200px;
  height: 170px;
  border-top-right-radius: 40%;
  border-top-left-radius: 73%;
  border-bottom-left-radius: 40%;
  border-bottom-right-radius: 73%;
  left: 150px;
  top: 60px;
}

.skill-text-2 {
  border-color: #f5db2c;
  color: #cfb200;
  width: 198px;
  height: 140px;
  border-top-right-radius: 80%;
  border-top-left-radius: 50%;
  border-bottom-left-radius: 80%;
  border-bottom-right-radius: 50%;
  left: 370px;
  top: -2px;
}

.skill-text-3 {
  border-color: #33c416;
  color: #33c416;
  width: 164px;
  height: 129px;
  border-top-right-radius: 80%;
  border-top-left-radius: 55%;
  border-bottom-left-radius: 80%;
  border-bottom-right-radius: 55%;
  left: 593px;
  top: 0px;
}

.skill-text-4 {
  border-color: #0450c3;
  color: #0450c3;
  width: 197px;
  height: 144px;
  border-top-right-radius: 50%;
  border-top-left-radius: 90%;
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 90%;
  left: 775px;
  top: 70px;
}

.skill-text-5 {
  border-color: #00b4f1;
  color: #00b4f1;
  width: 118px;
  height: 94px;
  border-top-right-radius: 80%;
  border-top-left-radius: 50%;
  border-bottom-left-radius: 80%;
  border-bottom-right-radius: 50%;
  left: 335px;
  top: 202px;
}

.skill-text-6 {
  border-color: #fa8500;
  color: #fa8500;
  width: 116px;
  height: 96px;
  border-top-right-radius: 50%;
  border-top-left-radius: 80%;
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 80%;
  left: 635px;
  top: 220px;
}

.skill-text-7 {
  border-color: #00963f;
  color: #00963f;
  width: 161px;
  height: 131px;
  border-top-right-radius: 50%;
  border-top-left-radius: 80%;
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 80%;
  left: 165px;
  padding-left: 10px;
  top: 296px;
}

.skill-text-8 {
  border-color: #ed1c24;
  color: #ed1c24;
  width: 160px;
  height: 120px;
  border-top-right-radius: 85%;
  border-top-left-radius: 55%;
  border-bottom-left-radius: 85%;
  border-bottom-right-radius: 55%;
  left: 780px;
  top: 285px;
}


@media (max-width: 1199px) {
  .green-lng {
    text-align: center;
  }
  .lng img {
    float: none;
    margin-right: 0px;
  }
  .de-img {
    margin-bottom: 4px;
  }
  .ch-img {
    margin-bottom: 13px;
  }
  .ru-img {
    margin-bottom: 7px;
  }
  .skill-text-1 {
    left: 70px;
  }
  .skill-text-4 {
    left: 725px;
  }
  .skill-text-5 {
    left: 211px;
  }
  .skill-text-8 {
    left: 745px;
  }
}

@media (max-width: 991px) {
  .skill-text-1 {
    left: 0px;
    top: 30px;
  }
  .skill-text-2 {
    left: 210px;
  }
  .skill-text-3 {
    left: 430px;
  }
  .skill-text-4 {
    left: 500px;
    top: 110px;
  }
  .skill-text-5 {
    left: 50px;
  }
  .skill-text-6 {
    left: 450px;
    top: 250px;
  }
  .skill-text-7 {
    left: 50px;
  }
  .skill-text-8 {
    left: 500px;
    top: 335px;
  }
}

@media (max-width: 767px) {
  .skill-text-4 {
    left: 395px;
  }
  .skill-text-7 {
    left: 0px;
  }
  .skill-text-8 {
    left: 395px;
  }
}

@media (max-width: 640px) {
  .lng {
    width: 50%;
    margin-right: 0;
    margin-left: 0
  }
  .skill-text-3 {
    left: 390px;
  }
  .skill-text-4 {
    left: 330px;
  }
  .skill-text-6 {
    left: 380px;
    top: 240px;
  }
  .skill-text-8 {
    left: 330px;
  }
}

@media (max-width: 575px) {
  .blue-wave-top, .blue-wave-bottom, .green-wave-bottom, .green-wave-top {
    background-size: auto;
  }
  .topchik h1 {
    margin-left: 15px;
  }
  .group {
    float: none;
    margin-left: 15px;
  }
  .prezent {
    text-align: center;
  }
  .prezent h2 {
    margin-left: 15px;
    margin-right: 15px;
    text-align: left;
  }
  .prezent h3 {
    margin-left: 15px;
    margin-right: 15px;
    text-align: left;
  }
  .prezent p {
    text-align: left;
  }
  .prezent img {
    float: none;
    margin-left: 15px;
    margin-top: 15px;
    margin-bottom: 30px;
  }
  .orange-knp {
    padding: 20px 30px;
  }
  .white-bg h2 {
    margin-left: 15px;
  }
  .nazan {
    margin-left: 0px;
  }
  .skill-wrapper img {
    width: 133px;
    margin-left: 0px;
    margin-top: 264px;
  }
  .urok {
    height: 755px;
  }
  .skill-text-4 {
    left: 47%;
    top: 0px;
  }
  .skill-text-2 {
    left: 10%;
    top: 85px;
  }
  .skill-text-1 {
    top: 459px;
    left: 20px;
  }
  .skill-text-3 {
    left: 49%;
    top: 180px;
  }
  .skill-text-7 {
    left: 49%;
    top: 535px;
  }
  .skill-text-5 {
    left: 28px;
    top: 318px;
  }
  .skill-text-8 {
    top: 635px;
    left: 50px;
  }
  .skill-text-6 {
    left: 62%;
    top: 375px;
  }
  .mbpt {
    padding-bottom: 10px !important;
  }

}

</style>
